import React, { useEffect, useState } from "react";
import {
  Grid,
  Card,
  Typography,
  Box,
  IconButton,
  InputAdornment,
  TextField,
  DialogContent,
  Dialog,
  DialogTitle,
  FormControl,
  InputLabel,
  OutlinedInput,
  MenuItem,
  Checkbox,
  ListItemText,
  CardContent,
} from "@mui/material";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  failOutFeedInspection,
  getBatchId,
  getOutFeedDefectsList,
  getOutFeedVisualInspectionData,
  submitOutFeedVisualInspection,
} from "./services";
import { toast, ToastContainer } from "react-toastify";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import Button from "../../components/Button/Button";

const items = Array.from({ length: 40 }, (_, i) => i + 1);

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const PassFailGrid = () => {
  const [open, setOpen] = useState(false);
  const [personName, setPersonName] = useState([]);
  const [defectListData, setDefectListData] = useState([]);
  const [feedVisualData, setFeedVisualData] = useState([]);
  const [batchData, setBatchData] = useState([]);
  const [feedBackData, setFeedBackData] = useState("");
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [defectCheckbox, setDefectCheckbox] = useState([]);
  const [selectedDefects, setSelectedDefects] = useState([]);
  const [isSubmit, setSubmit] = useState("");
  const [isOpenPopup, setIsOpenPopup] = useState(false);
  const [isOpenData, setIsOpenData] = useState(false);
  const { username } = useSelector((state) => state.userState);
  const location = useLocation();
  const params = useParams();
  // const batchType = location.state?.batch_types;
  const batchType = location.state?.batch_types || params.id;
  const handleChange = (event) => {
    const {
      target: { value },
    } = event;

    setPersonName(value);
  };

  console.log("isSubmit", isSubmit);
  useEffect(() => {
    if (selectedItemId?.fail_ofvi?.defects) {
      setPersonName(selectedItemId.fail_ofvi.defects);
    } else {
      setPersonName([]);
    }
  }, [selectedItemId]);

  useEffect(() => {
    if (selectedItemId?.fail_ofvi?.feedback) {
      setFeedBackData(selectedItemId.fail_ofvi.feedback);
    } else {
      setFeedBackData("");
    }
  }, [selectedItemId]);

  const handleOpenPopup = (itemId) => {
    setSelectedItemId(itemId);
    setOpen(true);
  };

  console.log("selectedItemId", selectedItemId);

  // const handleChange = (event) => {
  //   setPersonName(event.target.value);
  // };

  const handleClose = () => {
    setOpen(false);
  };
  const navigate = useNavigate();
  const param = useParams();

  useEffect(() => {
    handleDefectList();
  }, []);

  const handleDefectList = async () => {
    try {
      const resp = await getOutFeedDefectsList();
      if (resp.status == 200 || resp.status == 201) {
        setDefectListData(resp.data.payload);
      }
    } catch (error) {
      setDefectListData([]);
    }
  };

  useEffect(() => {
    getBatchData();
  }, [param.id]);

  const getBatchData = async () => {
    try {
      const resp = await getBatchId(param.id);
      if (resp.status == 200 || resp.status == 201) {
        setBatchData(resp.data);
      }
    } catch (error) {
      setBatchData([]);
    }
  };
  useEffect(() => {
    handleFeedData();
  }, [param.id]);

  const handleFeedData = async () => {
    try {
      const resp = await getOutFeedVisualInspectionData(param.id);
      if (resp.status == 200 || resp.status == 201) {
        setFeedVisualData(resp.data.payload);
        setSubmit(resp.data.payload.is_batch_submitted);
      }
    } catch (error) {
      toast.error(error.response.data.message);
      setFeedVisualData([]);
    }
  };

  const handleClick = async () => {
    const params = {
      sub_part_id: selectedItemId.id,
      is_fail: true,
      defects: personName,
    };

    if (selectedItemId?.fail_ofvi?.id) {
      params["fail_ofvi_id"] = selectedItemId?.fail_ofvi?.id;
    }
    if (feedBackData !== "") {
      params["feedback"] = feedBackData;
    }
    try {
      const resp = await failOutFeedInspection(params);
      if (resp.status == 200 || resp.status == 201) {
        toast.success(resp.data.message);
        setOpen(false);
        setIsOpenData(false);
        handleFeedData();
      }
    } catch (error) {
      setOpen(false);
      toast.error(error.response.data.message);
    }
  };

  const handleSubmitData = async () => {
    const params = {
      batch_id: param.id,
    };
    try {
      const resp = await submitOutFeedVisualInspection(params);
      if (resp.status == 200 || resp.status == 201) {
        toast.success(resp.data.message);
        setIsOpenPopup(false);
        handleFeedData();
      }
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  const handleSubmit = () => {
    setOpen(false);
    setIsOpenPopup(true);
    setIsOpenData(false);
  };
  const handleSubmitData1 = () => {
    setOpen(false);
    setIsOpenData(true);
    setIsOpenPopup(false);
  };

  return (
    <div className="min-h-screen  p-8 dashboard-wrapper page-wraper">
      <ToastContainer />
      <div className="page-header">
        <div
          onClick={() =>
            navigate(`/production-line`, {
              state: { batch_types: batchType },
            })
          }
          className="page-back-btn"
          style={{ cursor: "pointer" }}
        >
          <ArrowBackIcon />
          <span>Out Feed Visual inspections</span>
        </div>
        <div>
          <button
            className={`submit-feed-submit ${isSubmit ? "disabled" : ""}`}
            onClick={handleSubmit}
            disabled={isSubmit}
          >
            Submit
          </button>
        </div>
      </div>
      <Grid container spacing={2} justifyContent="center">
        {feedVisualData?.ofvi_sub_parts
          ?.sort(
            (a, b) => Number(a.sub_part_number) - Number(b.sub_part_number)
          )
          .map((item) => (
            <Grid item key={item.sub_part_number} xs={6} sm={3} md={2} lg={1.5}>
              <Box
                sx={{ p: 2, textAlign: "center", borderRadius: 3 }}
                className={
                  item.is_fail
                    ? "visual-inspection-feed-fail"
                    : isSubmit
                    ? "visual-inspection-feed-pass"
                    : "visual-inspection-feed"
                }
              >
                <Typography
                  variant="h5"
                  style={{ fontWeight: 700, color: "#001323" }}
                >
                  {String(item.sub_part_number).padStart(2, "0")}
                </Typography>
                <Grid
                  container
                  justifyContent="center"
                  spacing={1}
                  sx={{ mt: 1 }}
                >
                  {item.is_fail ? (
                    <Grid item>
                      <button
                        variant="outlined"
                        size="small"
                        className="fail-btn"
                        style={item.is_fail && isSubmit ? { pointerEvents: "none" } : {}}
                        onClick={() => handleOpenPopup(item)}
                      >
                        Fail
                      </button>
                    </Grid>
                  ) : isSubmit ? (
                    <Grid item>
                      <button
                        variant="outlined"
                        size="small"
                        className="pass-btn"
                        style={{pointerEvents: "none"}}
                        // onClick={() => handleOpenPopup(item)}
                      >
                        Pass
                      </button>
                    </Grid>
                  ) : (
                    <Grid item>
                      <button
                        variant="outlined"
                        size="small"
                        className="choose-defect-btn"
                        onClick={() => handleOpenPopup(item)}
                      >
                        Choose defects
                      </button>
                    </Grid>
                  )}
                </Grid>
              </Box>
            </Grid>
          ))}
      </Grid>

      <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
        <DialogTitle className="productionline-dialog-title">
          OUTFEED INSPECTION TABLE
        </DialogTitle>
        <DialogContent className="mt-3">
          <div
            // key={field.name}
            style={{ marginBottom: "10px", marginTop: "10px" }}
          >
            <label
              style={{ display: "block", fontSize: "14px" }}
              className="mb-1"
            >
              Date
            </label>
            <TextField
              fullWidth
              size="small"
              variant="filled"
              InputProps={{
                disableUnderline: true,
              }}
              value={dayjs(selectedItemId?.created_at).format("YYYY-MM-DD")}
              className="production-line-popup-input-field mb-2"
              disabled
            />

            <label
              style={{ display: "block", fontSize: "14px" }}
              className="mb-1"
            >
              Time
            </label>
            <TextField
              fullWidth
              size="small"
              variant="filled"
              InputProps={{
                disableUnderline: true,
              }}
              value={dayjs(selectedItemId?.created_at).format("hh:mm:ss")}
              className="production-line-popup-input-field mb-2"
              disabled
            />
            <label
              style={{ display: "block", fontSize: "14px" }}
              className="mb-1"
            >
              Defect List
            </label>
            <FormControl sx={{ width: "100%" }} className="mb-2">
              <InputLabel id="demo-multiple-checkbox-label">
                Select Defect
              </InputLabel>
              <Select
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                multiple
                value={personName} // personName should store defect IDs
                onChange={handleChange}
                input={<OutlinedInput label="Select Defect" />}
                renderValue={(selected) =>
                  defectListData
                    .filter((defect) => selected.includes(defect.id))
                    .map((defect) => defect.name)
                    .join(", ")
                }
                sx={{ backgroundColor: "#f0f0f0" }}
              >
                {defectListData.map((defect) => (
                  <MenuItem key={defect.id} value={defect.id}>
                    <Checkbox checked={personName.includes(defect.id)} />
                    <ListItemText primary={defect.name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <label
              style={{ display: "block", fontSize: "14px" }}
              className="mb-1"
            >
              Batch No.
            </label>
            <TextField
              fullWidth
              size="small"
              variant="filled"
              InputProps={{
                disableUnderline: true,
              }}
              value={batchData.batch_type}
              className="production-line-popup-input-field mb-2"
              disabled
            />
            <label
              style={{ display: "block", fontSize: "14px" }}
              className="mb-1"
            >
              Shift
            </label>
            <TextField
              fullWidth
              size="small"
              variant="filled"
              InputProps={{
                disableUnderline: true,
              }}
              value={batchData.shift_name}
              className="production-line-popup-input-field mb-2"
            />
            <label
              style={{ display: "block", fontSize: "14px" }}
              className="mb-1"
            >
              Operator
            </label>
            <TextField
              fullWidth
              size="small"
              variant="filled"
              InputProps={{
                disableUnderline: true,
              }}
              value={username}
              className="production-line-popup-input-field mb-2"
            />
            <label
              style={{ display: "block", fontSize: "14px" }}
              className="mb-1"
            >
              Feedback
            </label>
            <TextField
              fullWidth
              size="small"
              variant="filled"
              value={feedBackData}
              name="feedBackData"
              onChange={(e) => setFeedBackData(e.target.value)}
              rows={3}
              multiline
              InputProps={{
                disableUnderline: true,
              }}
              className="production-line-popup-input-field mb-2"
            />
          </div>

          <Button
            className="disabled-data"
            title="Submit"
            style={{
              marginTop: "15px",
              backgroundColor: "#0d3b66",
              width: "100%",
              padding: "11px",
            }}
            onClick={handleSubmitData1}
            disabled={isSubmit}
          />
        </DialogContent>
      </Dialog>
      {isOpenPopup && (
        <div className="sendingdataaaa1">
          <Card className="pairingcard-Approved">
            <CardContent className="p-0 pairing-status">
              <h4>Are you sure you want to submit the data?</h4>
            </CardContent>
            <Button
              className="pairingcard-btn-data"
              title="Yes"
              onClick={() => handleSubmitData()}
            />
            <Button
              className="pairingcard-btn"
              title="No"
              onClick={() => setIsOpenPopup(false)}
            />
          </Card>
        </div>
      )}
      {isOpenData && (
        <div className="sendingdataaaa1">
          <Card className="pairingcard-Approved">
            <CardContent className="p-0 pairing-status">
              <h4>Are you sure you want to submit the data?</h4>
            </CardContent>
            <Button
              className="pairingcard-btn-data"
              title="Yes"
              onClick={() => handleClick()}
            />
            <Button
              className="pairingcard-btn"
              title="No"
              onClick={() => setIsOpenData(false)}
            />
          </Card>
        </div>
      )}
    </div>
  );
};

export default PassFailGrid;
